/**
 * @generated SignedSource<<4c26821fe85dc62c307bcff09caf1759>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedMeetTheSeller_user$data = {
  readonly canShowSellerName: boolean | null;
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedContactSellerButton_user">;
  readonly " $fragmentType": "PdpSharedMeetTheSeller_user";
};
export type PdpSharedMeetTheSeller_user$key = {
  readonly " $data"?: PdpSharedMeetTheSeller_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedMeetTheSeller_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedMeetTheSeller_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedContactSellerButton_user"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f9633de8ae534bfcbff3dd09f7c6d976";

export default node;
